import { render, staticRenderFns } from "./CollegeManagement.vue?vue&type=template&id=029be29e"
import script from "./CollegeManagement.vue?vue&type=script&lang=js"
export * from "./CollegeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports